import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-sm-row location" }
const _hoisted_2 = {
  key: 0,
  class: "mb-3 mr-sm-4 location-image"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 3,
  class: "location-mobile active-on-platform"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Active on Openbay", -1)
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { class: "distance-from" }
const _hoisted_10 = {
  key: 5,
  class: "location-mobile"
}
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReviewSummary = _resolveComponent("ReviewSummary")!
  const _component_LocationAmenities = _resolveComponent("LocationAmenities")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.displayLogo && _ctx.location.logoImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "img-fluid rounded",
            src: _ctx.logo(_ctx.location)
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (!_ctx.headerRoute)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "h2 name location-shop-name",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('location-clicked')))
          }, _toDisplayString(_ctx.location.name), 1))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "h2 name location-shop-name",
            href: _ctx.headerRoute
          }, _toDisplayString(_ctx.location.name), 9, _hoisted_4)),
      (_ctx.location.reviewSummary.rating > 0)
        ? (_openBlock(), _createBlock(_component_ReviewSummary, {
            key: 2,
            "review-summary": _ctx.location.reviewSummary,
            onRatingsClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('ratings-clicked')))
          }, null, 8, ["review-summary"]))
        : _createCommentVNode("", true),
      (_ctx.showActiveOnPlatofrm && _ctx.location.activeForMarketplace)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.asset(require('@/assets/images/logo_openbay_blue_car.svg'))
            }, null, 8, _hoisted_6),
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (!_ctx.location.doesHouseCalls)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
            (_ctx.distanceFrom)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.distanceFrom) + " mi", 1),
                  _createTextVNode(" - ")
                ], 64))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.location.address), 1)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_10, [
            _createElementVNode("img", {
              src: _ctx.asset(require('@/assets/images/shipping-fast.svg'))
            }, null, 8, _hoisted_11),
            _createTextVNode(" Mobile mechanic. We come to you! ")
          ])),
      (!_ctx.isAdminFlow)
        ? (_openBlock(), _createBlock(_component_LocationAmenities, {
            key: 6,
            location: _ctx.location,
            class: "mb-3"
          }, null, 8, ["location"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}